import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { ApiService } from '../base';

@Injectable()
export class CompanyService extends ApiService {
  createNewCompany(request: any): Observable<any> {
    return this.post('/backoffice/api/customers', request);
  }

  searchByNameCompany(request: any): Observable<any> {
    return this.post('/backoffice/api/customers/searchByName', request);
  }

  getOneByNameCompany(param: any): Observable<any> {
    return this.get(`/backoffice/api/customers/${param}`);
  }

  updateOneByNameCompany(request:any):Observable<any> {
    return this.put('/backoffice/api/customers', request);
  }


}
